import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAgencyUser } from 'redux/selectors';
import { useSelectorListState } from 'helpers/hooks';
import useManageSocialWorkerState from '../utils/useManageSocialWorkerState';
import { useGetSocialWorkerButtons } from '../utils/useGetSocialWorkerButtons';
import { useGetRoleChangeButtons } from 'helpers/useGetRoleChangeButtons';
import {
	PageLayout,
	FormSectionHeader,
	RoleChangeButton,
	ChangeRole,
} from 'components';
import * as SwComp from './index';

export default function ManageSocialWorker() {
	const { swId } = useParams();
	const updatedRole = useSelector((state) => state.user.updateRole);
	const userRole = useSelector((state) => state.user.user.role);
	const socialWorker = useSelector(getAgencyUser(swId));
	const {
		pageTitle,
		childList,
		assignedChildren,
		managerList,
		assignedManager,
		role,
		loaded,
	} = useManageSocialWorkerState(socialWorker.id);

	const managerListState = useSelectorListState(managerList, assignedManager, {
		single: true,
		loaded,
	});

	const childListState = useSelectorListState(childList, assignedChildren, {
		loaded,
	});

	const [updateRole, setUpdateRole] = useState(false);

	const resetListChanges = () => {
		managerListState.resetChanges();
		childListState.resetChanges();
	};

	const getUpdatedChildIds = () => {
		const { add, remove } = childListState?.changes || {};
		if (!(add.length > 0) && !(remove.length > 0)) return;

		const newList = [...assignedChildren];
		const filteredList = newList.filter((val) => {
			return remove.findIndex((removeVal) => {
				return removeVal.id === val.id;
			});
		});

		return add
			.reduce(
				(acc, cur) => {
					acc.push(cur);
					return acc;
				},
				[...filteredList]
			)
			.map((val) => val.id);
	};

	const getBody = () => {
		const reqBody = { id: swId };
		if (role !== 'social-worker') {
			reqBody.role = role;
		}
		const { add, remove } = managerListState?.changes || {};
		const updatedChildIds = getUpdatedChildIds();

		if (updatedChildIds) {
			reqBody.childIds = updatedChildIds;
		}

		if (add.length > 0) {
			reqBody.managerAgencyUserId = add[0].id;
		} else if (remove.length > 0) {
			reqBody.managerAgencyUserId = '';
		}

		return reqBody;
	};

	const roleChangeButtons = useGetRoleChangeButtons(
		swId,
		updatedRole,
		socialWorker.role
	);
	const swButtons = useGetSocialWorkerButtons(getBody, resetListChanges);

	const buttonArray = updateRole ? roleChangeButtons : swButtons;

	const handleOnClick = () => {
		setUpdateRole(true);
	};

	return (
		<PageLayout title={pageTitle} buttonArray={buttonArray} align='left'>
			{updateRole ? (
				<ChangeRole id={swId} />
			) : (
				<>
					<SwComp.SocialWorkerBasicInfo />
					<SwComp.SocialWorkerBranch />
					<SwComp.SocialWorkerManagerList
						selectorListState={managerListState}
					/>
					<SwComp.SocialWorkerChildList selectorListState={childListState} />
					<FormSectionHeader hideTop>Management Options</FormSectionHeader>
					{userRole === 'admin' && (
						<RoleChangeButton handleOnClick={handleOnClick} />
					)}
					<SwComp.EnableSwPrivilege />
				</>
			)}
		</PageLayout>
	);
}
